import { defaultListData, defaultListState } from 'bv-data'
import type { ListModel, ListModelState } from '@/types'
import { getQuery } from 'bv-utils'
import type { IDistributeMailType, IMailAddresseeInfo } from '@/services/distributeMail/addressee'
import type { IMailAppealInfo } from '@/services/distributeMail/appeal'
import type { IMailReminderInfo } from '@/services/distributeMail/reminder'
import { listService } from '@/services/distributeMail'
import { putSave } from '@/models/utils'

type IDistributeMailInfo = {

} & IMailAddresseeInfo & IMailAppealInfo | IMailReminderInfo

export type MailModelState = ListModelState<IDistributeMailInfo> & { id: number, type: IDistributeMailType};
export type MailListModel = ListModel<MailModelState, 'mail'>;


const listState: MailModelState = { ...defaultListState, id: 0, type: '' }

const MailModel: MailListModel = {
  namespace: 'mail',
  state: listState,
  effects: {
    * list ({ params }, { call, put, select }) {
      const id: number = yield select((state: any) => state.mail.id)
      const requestId = id + 1
      yield put(putSave({ id: requestId, type: params, loading: true }))
      const [ data, error ] = yield call(listService[params], getQuery())
      const currentId: number = yield select((state: any) => state.mail.id)
      if (currentId === requestId) {
        yield put(putSave({  error,  data: data ?? defaultListData, loading: false }))
      }
    },
  },

  reducers: {
    clean (state) {
      return { ...state, ...defaultListState }
    },
    reset () {
      return listState
    },
    save (state, { payload = {} }) {
      return { ...state, ...payload }
    },
  },
}

export default MailModel
